import { render, staticRenderFns } from "./DataCorrectionForms.vue?vue&type=template&id=42854099&scoped=true&"
import script from "./DataCorrectionForms.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionForms.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionForms.vue?vue&type=style&index=0&id=42854099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42854099",
  null
  
)

export default component.exports